module.exports = __webpack_public_path__ + "img/store_detail_bg_0.b184a05a.png";